import { doc, setDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../../firebase";
import { completeInventoryUsage, TA_INVENTORY_KEY } from "../../access/accessService";
import { kotayiTuketGuvenli } from "../../access/kotaTuket";
import { buildTaEgoReportSummary } from "../report/taEgoReportEngine";

// Firebase console'da kayıtların isim-soyisimle görünmesi için doküman ID'sini
// okunabilir yapar: "İsim Soyisim — 2026-06-25 1046 a1b2"
// (tarih + kısa rastgele ek aynı isimde çakışmayı önler).
function buildEgoResultId(userInfo) {
  const name = String(userInfo?.name || userInfo?.fullName || userInfo?.adSoyad || "").trim();
  const surname = String(userInfo?.surname || userInfo?.lastName || "").trim();
  const label = [name, surname].filter(Boolean).join(" ").trim() || "Anonim";

  const d = new Date();
  const p = (n) => String(n).padStart(2, "0");
  const stamp = `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}${p(d.getMinutes())}`;
  const rand = Math.random().toString(36).slice(2, 6);

  // "/" yol ayıracıdır; baştaki/sondaki noktalar ID'de geçersizdir.
  return `${label} — ${stamp} ${rand}`
    .replace(/\//g, "-")
    .replace(/^\.+|\.+$/g, "")
    .slice(0, 200);
}

function cleanAccessContext(accessContext) {
  if (!accessContext?.accessCode) return null;

  return {
    accessCode: accessContext.accessCode,
    inventoryKey: TA_INVENTORY_KEY,
    companyId: accessContext.companyId || "",
    companyName: accessContext.companyName || "",
    teamId: accessContext.teamId || "",
    teamName: accessContext.teamName || "",
  };
}

export const saveEgoResult = async (userInfo, answers, scores, accessContext, language, durationMs) => {
  try {
    const access = cleanAccessContext(accessContext);
    const safeDurationMs =
      Number.isFinite(Number(durationMs)) && Number(durationMs) > 0
        ? Math.round(Number(durationMs))
        : null;
    const reportSummary = buildTaEgoReportSummary({
      scores,
      participant: {
        name: userInfo?.name || userInfo?.fullName || userInfo?.adSoyad || "",
        surname: userInfo?.surname || userInfo?.lastName || "",
        company: access?.companyName || "",
        team: access?.teamName || "",
        generationRange: userInfo?.generationRange || "",
        roleLevel: userInfo?.roleLevel || "",
      },
      language,
    });

    const docRef = doc(db, "egoResults", buildEgoResultId(userInfo));
    await setDoc(docRef, {
      user: userInfo,
      answers: answers,
      scores: scores,
      reportSummary,
      access,
      durationMs: safeDurationMs,
      durationSeconds: safeDurationMs != null ? Math.round(safeDurationMs / 1000) : null,
      createdAt: serverTimestamp()
    });

    if (access?.accessCode) {
      // Kota tüketimi çakışma yüzünden düşebiliyor (tüm tüketimler tek lisans
      // belgesinin sayaçlarını günceller). Eskiden hata yutuluyordu: kayıt
      // kalıyor, kota düşmüyordu. Şimdi yeniden denenir; yine olmazsa kayıt
      // `quotaPending` ile işaretlenir ki mutabakat yapılabilsin.
      const kotaSonucu = await kotayiTuketGuvenli(
        () => completeInventoryUsage({
        accessCode: access.accessCode,
        inventoryKey: TA_INVENTORY_KEY,
        resultId: docRef.id,
        participantName: userInfo?.name || userInfo?.fullName || userInfo?.adSoyad || "",
        language,
      })
      );
      if (!kotaSonucu.ok) {
        console.warn(
          "[kota] TA / 3 Ego: kayıt yazıldı ama kota düşmedi — quotaPending işaretlendi"
        );
      }
    }

    return true;
  } catch (err) {
    console.error("EGO result save error:", err);
    return false;
  }
};
